module.exports = __webpack_public_path__ + "img/234.3f1c575.png";